export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10893.d33d93e7.jpg";